import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const HeartSmall = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 20 20", fill: "currentColor", width: size || "20", height: size || "20" }, props),
        React.createElement("g", { id: "Reaction-/-Small-/-Heart_Small_20X20", stroke: "none", fill: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("path", { d: "M0.3408,9.2104 C1.4528,12.8764 7.3688,17.1864 9.3538,18.5464 C9.7498,18.8174 10.2548,18.8174 10.6508,18.5464 C12.6348,17.1854 18.5458,12.8764 19.6588,9.2104 C19.9838,8.2704 20.0918,7.2154 19.9158,6.1194 C19.5308,3.7234 17.7408,1.7774 15.5068,1.3484 C13.2478,0.9144 11.1808,1.9564 9.9998,3.7254 C8.8198,1.9564 6.7518,0.9144 4.4928,1.3484 C2.2588,1.7774 0.4688,3.7234 0.0838,6.1194 C-0.0922,7.2164 0.0168,8.2704 0.3408,9.2104", id: "Heart", fill: "#F5592D" }))));
};
HeartSmall.displayName = 'HeartSmall';
export default HeartSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=HeartSmall.js.map